import Fab from "@mui/material/Fab";
import { PropTypes } from "prop-types";

const ButtonCancel = (props) => {
  return (
    <Fab
      sx={{
        width: 100,
        background: "red",
        color: "white",
        "&:hover": {
          backgroundColor: "#8B0000",
          color: "#fefefe",
        },
      }}
      variant="extended"
      onClick={props.handleClick}
    >
      Ακύρωση
    </Fab>
  );
};

export default ButtonCancel;

ButtonCancel.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
